export default "__VITE_ASSET__DMigdQWI__"